import Index from '../pages/Index.vue';
import Single from '../pages/inventory/Single.vue';
import NotFound from '../pages/NotFound.vue';

export default {
    routes: [{
        path: '/',
        component: Index,
        name: 'inventory',
        meta: {
            name: 'Dealer Inventory'
        }
    }, {
        props: true,
        path: '/inventory/:id',
        component: Single,
        name: 'inventory-single',
        meta: {
            name: 'Dealer Inventory Boat'
        }
    }, {
    	path: '*',
        component: NotFound,
    	name: 'not-found',
        meta: {
            name: '404 Not Found'
        }
    }]
}